import validator from 'validator';
import iban from 'iban'
import moment from "moment";

export function validate(fieldName, value, rules, messages, label) {
	let result = objectRulesControl(rules[fieldName], value, label);
	messages[fieldName] = result.message;
	return {
		messages: messages,
		valid: checkValid(messages)
	}
}

function checkValid(messages) {
	let valid = true;
	for (var message in messages) {
		if (messages[message] !== '') {
			return false;
		}
	}
	return valid;
}

function objectRulesControl(rules, value, label) {
	let result = {state: true, message: ''};
	for (var rule in rules) {
		let ruleKey = rule;
		let ruleValue = rules[rule];
		result = getValidationResult(ruleKey, ruleValue, value, label);
		if (!result.state) {
			return result;
		}
	}
	return result;
}


export function validateComponent(obj) {
	let error = obj.state.error;
	var refs = obj.refs;
	var isValid = true;
	for (var key in refs) {
		var ref = refs[key];

		// SELECT MENU, DATA'YI PROPS ALTINDA TUTUYOR
		if (ref.props) {
			let rule = null;
			let boundary = null;
			let result = null;
			if (ref.props.inputProps && ref.props.inputProps.dataset) {
				rule = ref.props.inputProps.dataset.vdata;
				boundary = ref.props.inputProps.dataset.vlength
				result = validateField(rule, boundary, (ref.props.inputProps.dataset.value === undefined ? '' : ref.props.inputProps.dataset.value));
			} else {
				rule = ref.props.inputProps.vdata;
				boundary = ref.props.inputProps.vlength
				result = validateField(rule, boundary, (ref.props.value === undefined ? '' : ref.props.value));
			}
			error = Object.assign(error, {[key]: result});
			if (!result.valid)
				isValid = false;
		} else {
			let rule = ref.dataset.vdata;
			let boundary = ref.dataset.vlength;
			let result = validateField(rule, boundary, (ref.value === undefined ? '' : ref.value));
			error = Object.assign(error, {[key]: result});
			if (!result.valid)
				isValid = false;
		}

	}
	return {valid: isValid, error: error};
}

export function validateCustom(booleanExpression, message) {
	return {valid: booleanExpression, message: (booleanExpression ? '' : message)};
}

export function validateField(rule, boundary, value) {
	value = (value !== 0 && !value ? '' : value.toString());
	let result = {valid: true, message: ''};
	if (boundary !== undefined) {
		let limit = boundary.split(',');

		if ((parseInt(limit[0]) > 0) && (value.length === 0) && !(rule==="phone")) {
			return result = {valid: false, message: ' Alanı boş bırakılamaz!'}
		}
		if (parseInt(limit[0]) > value.length && !(value.length === 0)) {
			return result = {valid: false, message: ' Alanı en az ' + limit[0] + ' karakterle sınırlandırılmıştır.'}
		}
		if ((parseInt(limit[1]) !== 0) && (parseInt(limit[1]) < value.length)) {
			return result = {valid: false, message: ' Alanı en fazla ' + limit[1] + ' karakterle sınırlandırılmıştır.'}
		}
		else {
			if (rule !== undefined) {
				if (rule.endsWith('Moment') || rule.includes('smallerThanOrEquals')) {
					return result = getValidationResult(rule, boundary, value, '');
				} else {
					return result = getValidationResult(rule, true, value, '');
				}
			}
		}
	} else {
		if (rule !== undefined)
			return result = getValidationResult(rule, true, value, '');

	}
	return result;
}

export function validateForeignCustomerPhone(rule, boundary, value) {
	value = (value !== 0 && !value ? '' : value.toString());
	let result = {valid: true, message: ''};
	if (boundary !== undefined) {
		let limit = boundary.split(',');

		if (rule==="phone" && !(value.startsWith("+")) && !(value.length === 0)) {
			return result = {valid: false, message: ' Telefon alanı + karakteri ile başlamalıdır.'}
		}
		if (parseInt(limit[0]) > value.length && !(value.length === 0)) {
			return result = {valid: false, message: ' Telefon Alanı en az ' + limit[0] + ' karakterle sınırlandırılmıştır.'}
		}
		if ((parseInt(limit[1]) !== 0) && (parseInt(limit[1]) < value.length)) {
			return result = {valid: false, message: ' Telefon Alanı en fazla ' + limit[1] + ' karakterle sınırlandırılmıştır.'}
		}
		else {
			if (rule !== undefined) {
				if (rule.endsWith('Moment') || rule.includes('smallerThanOrEquals')) {
					return result = getValidationResult(rule, boundary, value, '');
				} else {
					return result = getValidationResult(rule, true, value, '');
				}
			}
		}
	} else {
		if (rule !== undefined)
			return result = getValidationResult(rule, true, value, '');

	}
	return result;
}

export function getValidationResult(ruleKey, ruleValue, value, label) {
	let result = {valid: true, message: ''};
	switch (ruleKey) {
		case 'required':
			result.valid = (ruleValue === false ? true : (!validator.isEmpty(value)));
			result.message = result.valid === true ? '' : `${label} alanı zorunludur.`;
			break;
		case 'maxLength':
			result.valid = validator.isLength(value, {max: ruleValue});
			result.message = result.valid === true ? '' : label + ' maksimum ' + ruleValue + ' karakter olmalıdır.';
			break;
		case 'date':
			result.valid = validator.isEmpty(value) || moment(value, "DD-MM-YYYY", true).isValid() || moment(value, "YYYY-MM-DD", true).isValid();
			result.message = result.valid === true ? '' : 'Tarih formatı uygun değil.';
			break;
		case 'year':
			result.valid = validator.isEmpty(value) || moment(value, "YYYY", true).isValid();
			result.message = result.valid === true ? '' : 'Tarih formatı uygun değil.';
			break;
		case 'periodDate':
			result.valid = validator.isEmpty(value) || moment(value, "MM-YYYY", true).isValid() || moment(value, "YYYY-MM", true).isValid();
			result.message = result.valid === true ? '' : 'Dönem formatı uygun değil.';
			break;
		case 'datetime':
			result.valid = validator.isEmpty(value) || moment(value, "DD-MM-YYYY HH:mm:ss", true).isValid();
			result.message = result.valid === true ? '' : 'Tarih formatı GG-AA-YYYY SS:dd:ss biçiminde olmalıdır.';
			break;
		case 'datetimeWithT':
			result.valid = validator.isEmpty(value) || moment(value, "DD-MM-YYYYTHH:mm:ss", true).isValid() || moment(value, "DD-MM-YYYY", true).isValid();
			result.message = result.valid === true ? '' : 'Tarih formatı GG-AA-YYYY SS:dd:ss biçiminde olmalıdır.';
			break;
		case 'datetimeY':
			result.valid = validator.isEmpty(value) || moment(value, "YYYY-MM-DDTHH:mm:ss", true).isValid() || moment(value, "DD-MM-YYYY", true).isValid();
			result.message = result.valid === true ? '' : 'Tarih formatı YYYY-AA-GG SS:dd:ss biçiminde olmalıdır.';
			break;
		case 'time':
			result.valid = ruleValue === false ? true : (validator.isEmpty(value) ? true : new RegExp(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/g).test(value));
			result.message = result.valid === true ? '' : 'Zaman formatı uygun değil.';
			break;
		case 'email':
			result.valid = ruleValue === false ? true : validator.isEmpty(value) ? true : validator.isEmail(value);
			result.message = result.valid === true ? '' : label + 'e-Posta formatı uygun değil.';
			break;
		case 'url':
			result.valid = ruleValue === false ? true : (validator.isEmpty(value) ? true : new RegExp(/^(http(s){0,1}:\/\/)?([a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+.*)$/g).test(value));
			result.message = result.valid === true ? '' : label + 'Url formatı uygun değil.';
			break;
		case 'decimal':
			result.valid = ruleValue === false ? true : validator.isDecimal(value);
			result.message = result.valid === true ? '' : label + 'Sayı formatı uygun değil.';
			break;
		case 'uuid':
			result.valid = ruleValue === false ? true : (validator.isUUID(value));
			result.message = result.valid === true ? '' : label + 'UUID formatı uygun değil.';
			break;
		case 'identifier':
			result.valid = ruleValue === false ? true : (validator.isEmpty(value) ? true : new RegExp(/^(\d{10}|[1-9]\d{10})$/g).test(value));
			result.message = result.valid === true ? '' : label + 'TCKN/VKN formatı uygun değil.';
			break;
		case 'vkn':
			result.valid = ruleValue === false ? true : new RegExp(/^\d{10}$/g).test(value);
			result.message = result.valid === true ? '' : label + 'VKN formatı uygun değil.';
			break;
		case 'iban':
			result.valid = ruleValue === false ? true : (iban.isValid(value));
			result.message = result.valid === true ? '' : label + 'IBAN formatı uygun değil veya boşluk karakteri bulunmamalıdır.';
			break;
		case 'urn':
			result.valid = ruleValue === false ? true : (new RegExp(/^urn\:mail\:([_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*)@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/g).test(value))
			result.message = result.valid === true ? '' : label + 'Etiket formatı uygun değil.';
			break;
		case 'alias':
			result.valid = ruleValue === false ? true : (new RegExp(/^([_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*)@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/g).test(value))
			result.message = result.valid === true ? '' : label + 'Etiket formatı uygun değil veya türkçe karakter içermemelidir.';
			break;
		case 'faturano':
			result.valid = ruleValue === false ? true : (new RegExp(/^[A-Z0-9]{3}20[0-9]{2}[0-9]{9}$/g).test(value))
			result.message = result.valid === true ? '' : 'Geçersiz belge no elemanı değeri.  Belge no ABC2009123456789 formatında olmalıdır.';
			break;
		case 'integer':
			result.valid = (ruleValue === false ? true : validator.isInt(value))
			result.message = result.valid === true ? '' : label + ' sayısal bir değer olmalıdır.';
			break;
		case 'phone':
		case 'phoneRequired':
			result.valid = ruleValue === false ? true : (validator.isEmpty(value) && 'phone' === ruleKey ? true : new RegExp(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g).test(value));
			result.message = result.valid === true ? '' : 'Telefon numarası formatı uygun değil.';
			break;
		case 'kunyeNo':
			result.valid = ruleValue === false ? true : (value.length === 19);
			result.message = result.valid === true ? '' : 'Kunye numarası 19 hane olmalıdır.';
			break;
		case 'positive':
			result.valid = ruleValue === false ? true : (Math.sign(value) === 1);
			result.message = result.valid === true ? '' : label + ' pozitif bir değer olmalıdır.';
			break;
		case 'smallerThanOrEquals':
			result.valid = ruleValue === false ? true : !(ruleValue < value);
			result.message = result.valid === true ? '' : label + ruleValue +' den küçük veya eşit bir değer olmalıdır.';
			break;
		case 'deliveryPostalZone':
			result.valid = ruleValue === false ? true : (validator.isEmpty(value) ? false : new RegExp('^((0[1-9])|([1-7][0-9])|(8[0-1]))[0-9]{3}$').test(value));
			result.message = result.valid === true ? '' : label + 'Posta Kodu formatı uygun değil.';
			break;
		case 'deliveryBuildingNumber':
			result.valid = validator.isLength(value, { max: ruleValue });
			result.message = result.valid === true ? '' : 'Bina No' + label + ' maksimum ' + ruleValue + ' karakter olmalıdır.';
			break;
		case 'deliveryRoomNumber':
			result.valid = validator.isLength(value, { max: ruleValue });
			result.message = result.valid === true ? '' : 'Kapı No' + label + ' maksimum ' + ruleValue + ' karakter olmalıdır.';
			break;
		case 'bayiNo':
			result.valid = validator.isLength(value, { max: ruleValue });
			result.message = result.valid === true ? '' : 'Bayi No' + label + ' maksimum ' + ruleValue + ' karakter olmalıdır.';
			break;
		case 'subeNo':
			result.valid = validator.isLength(value, { max: ruleValue });
			result.message = result.valid === true ? '' : 'Şube No' + label + ' maksimum ' + ruleValue + ' karakter olmalıdır.';
			break;
		case 'deliveryRegion':
			result.valid = validator.isLength(value, { max: ruleValue });
			result.message = result.valid === true ? '' : 'Kasaba/Köy' + label + ' maksimum ' + ruleValue + ' karakter olmalıdır.';
			break;
		case 'deliveryStreet':
			result.valid = validator.isLength(value, { max: ruleValue });
			result.message = result.valid === true ? '' : 'Mah./Cad./Sokak' + label + ' maksimum ' + ruleValue + ' karakter olmalıdır.';
			break;
		case 'deliveryBuildingName':
			result.valid = validator.isLength(value, { max: ruleValue });
			result.message = result.valid === true ? '' : 'Bina Adı' + label + ' maksimum ' + ruleValue + ' karakter olmalıdır.';
			break;
		case 'gtip':
			result.valid = (ruleValue === false ? true : ((validator.isInt(value) || value.toString().length === 0) && !(value.toString().includes("+") || value.toString().includes("-"))));
			result.message = result.valid === true ? '' : label + 'Alan 12 sayıdan oluşan pozitif bir değer olmalıdır.';
			break;
		case 'blockTurkishSpecialCh':
			result.valid = ruleValue === false ? true : (new RegExp(/^[a-z@_.0-9]+$/i).test(value));
			result.message = result.valid === true ? '' : label + 'Türkçe ve özel karakter içermemelidir.';
			break;
		case 'bankName':
			result.valid = ruleValue === false ? true :  (!new RegExp("^\\s*$").test(value));
			result.message = result.valid === true ? '' : label + 'Şube adı formatı uygun değil.';
			break;
		case 'cellPhone':
			result.valid = ruleValue === false ? true : (validator.isEmpty(value) && 'cellPhone' === ruleKey ? true : new RegExp(/^\+905(0[1-7]|[1-6]\d)\d{3}\d{4}$/g).test(value));
			result.message = result.valid === true ? '' : 'Telefon numarası formatı uygun değil.';
			break;
		default:
			result = {valid: true, message: ''};
	}
	return result;
}

export function getValidationOfFinancial(ruleKey, ruleValue, value, label) {
	let result = { valid: true, message: '' };

	switch (ruleKey) {
		case 'string':
			result.valid = ruleValue === false ? true : new RegExp(/^[a-zA-ZğĞüÜşŞıİöÖçÇ\s]+$/g).test(value);
			break;
		case 'telephone':
			result.valid = ruleValue === false ? true : new RegExp(/^([1-9]{0,1}[0-9]{0,9})$/g).test(value);
			break;
		case 'identifier':
			result.valid = ruleValue === false ? true : (validator.isEmpty(value) ? true : new RegExp(/^([1-9]{1}[0-9]{10})$/g).test(value));
			break;
		case 'vergiDairesi':
			result.valid = ruleValue === false ? true : new RegExp("^[0-9a-zA-ZüğıçöşÜĞİÇÖŞÂâ .\\\\-_(),:/]+$").test(value);
			break;
		case 'vergiKimlikNo':
			result.valid = ruleValue === false ? true : new RegExp(/^([0-9]{10})$/g).test(value);
			break;
		case 'dogumYeri':
			result.valid = ruleValue === false ? true : new RegExp(/^[a-zA-ZğĞüÜşŞıİöÖçÇ0-9.()\\s-]{3,100}$/g).test(value);
			break;
		case 'date':
			result.valid = validator.isEmpty(value) || moment(value, "DD-MM-YYYY", true).isValid() || moment(value, "YYYY-MM-DD", true).isValid();
			break;
		case 'adres':
			result.valid = ruleValue === false ? true : new RegExp(/^[a-zA-Z0-9 .;\\-_=()+*,\r\n://\\ıüğşçöÜĞİŞÇÖ]{20,255}$/g).test(value);
			break;
		case 'email':
			result.valid = ruleValue === false ? true : new RegExp(/^(?=.{5,100}$)([A-Za-z0-9._%+-]+)@([A-Za-z0-9.-]+\.[A-Z|a-z]{2,})$/).test(value);
			break;
		default:
			return result;
	}
	result.message = result.valid ? '' : `${label} formatı uygun değil.`;
	return result;
}

export function validateFinancialField(rule, boundary, value, label) {
	value = (value !== 0 && !value ? '' : value.toString());
	let result = {valid: true, message: ''};
	if (boundary !== undefined) {
		let limit = boundary.split(',');
		if ((parseInt(limit[0]) > 0) && (value.length === 0)) {
			return  {valid: false, message: ' Alanı boş bırakılamaz!'}

		}
		if (parseInt(limit[0]) > value.length && !(value.length === 0)) {
			return   {valid: false, message: ' Alanı en az ' + limit[0] + ' karakterle sınırlandırılmıştır.'}
		}
		if ((parseInt(limit[1]) !== 0) && (parseInt(limit[1]) < value.length)) {
			return {valid: false, message: ' Alanı en fazla ' + limit[1] + ' karakterle sınırlandırılmıştır.'}
		} else {
			if (rule !== undefined) {
				return getValidationOfFinancial(rule, true, value, label);
			}
		}
	} else {
		if (rule !== undefined)
			return  getValidationOfFinancial(rule, true, value, label);

	}
	return result;
}


